import Listener from "~/ts/library/listen/Listener";
import Url from "~/ts/library/Url";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";

export default class OperatorCometListener {
    private static listener: Listener;

    public static create() {
        this.stop();
        this.listener = (new Listener());
        return this.listener;
    }

    public static start(currentCometTime?: number) {
        this.listener.start(this.channelId, this.websocketUrl, this.longPollUrl, currentCometTime);
    }

    public static get(): Listener | null {
        return this.listener;
    }

    private static get channelId() {
        return OperatorAccountStore.data.value.comet.channelId;
    }

    public static stop() {
        if (this.listener) {
            this.listener.destroy();
            this.listener = null;
        }
    }

    private static get isTest() {
        return !OperatorConfigStore.isProduction.value;
    }


    private static get credentialsQueryString() {
        return "?" + Url.toQueryString({
            operatorChannelId: this.channelId,
            tokenId: OperatorAccountStore.tokenId.value
        });
    }

    private static get domain(): string {
        return this.isTest ? "dev.apibcknd.com" : OperatorApplicationConfigInstance.productionHost;
    }

    public static get domainWithProtocol(): string {
        return `https://${this.domain}`;
    }

    private static get websocketUrl(): string {
        return (this.isTest ? `wss://${this.domain}` : `wss://${this.domain}`) + "/comet/websocket" + this.credentialsQueryString;
    }

    private static get longPollUrl(): string {
        let host = this.isTest ? `https://${this.domain}` : `https://${this.domain}`;
        return host + "/comet/longPolling" + this.credentialsQueryString;
    }
};
